import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import ModalHeader from '../../common/modal/header';
import DataCandyModal from '../../order.loyalty/datacandy/loyalty-modal';
import SpoonityModal from '../../order.loyalty/spoonity-loyalty/loyalty-modal';
import ComoModal from "@/desktop/order.loyalty/como/loyalty-modal";

export const schemes = {
    DataCandyLoyalty: { component: DataCandyModal },
    SpoonityLoyalty: { component: SpoonityModal },
    ComoLoyalty: { component: ComoModal }
};

const LoyaltyModal = forwardRef(
    ({ closeModal, loyaltyScheme, cardStatus }, ref) => {
        const scheme = schemes[loyaltyScheme];

        if (!scheme) return null;

        const MatchingComponent = scheme.component;

        const [t] = useTranslation('loyalty');

        return (
            <div className="m2g-customer-loyalty">
                <ModalHeader
                    headerText={t('title')}
                    onClose={closeModal}
                    hideCloseButton={false}
                />
                <MatchingComponent
                    closeModal={closeModal}
                    cardStatus={cardStatus}
                />
            </div>
        );
    }
);

export default LoyaltyModal;
